import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { useGlobalContext } from '@slc/tools/GlobalContext';
import { SchedulerStatus } from '@repo/types';

// 30 seconds cache - live game status can change frequently
const CACHE_TIME = 30 * 1000;

export const useSchedulerStatusQuery = () => {
  const { apiUrl } = useGlobalContext();

  return useQuery({
    queryKey: ['scheduler-status', apiUrl],
    queryFn: () => fetchSchedulerStatus(apiUrl),
    staleTime: CACHE_TIME,
    refetchInterval: CACHE_TIME,
    enabled: !!apiUrl,
  });
};

const fetchSchedulerStatus = async (apiUrl: string): Promise<SchedulerStatus> => {
  const { data } = await axios.get<SchedulerStatus>(`${apiUrl}${API.endpoints.schedulerStatus}`);
  return data;
};
